import { useNinetailed, NinetailedProvider as NinetailedProvider$1 } from '@ninetailed/experience.js-react';
export * from '@ninetailed/experience.js-react';
export * from '@ninetailed/experience.js-plugin-ssr';
export { decodeExperienceVariantsMap } from '@ninetailed/experience.js';
import { useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import { logger } from '@ninetailed/experience.js-shared';
import { jsxs, jsx } from 'react/jsx-runtime';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

const Tracker = ({
  onRouteChange
}) => {
  const router = useRouter();
  const ninetailed = useNinetailed();
  const lastFiredPageRef = useRef('none');
  useEffect(() => {
    logger.debug('Ninetailed Next.js Tracker', 'The useEffect hook to listen for route changes got called. On instantiation the last fired page is:', lastFiredPageRef.current);
    const handleRouteChange = url => {
      const isPageAlreadyTracked = lastFiredPageRef.current === url || lastFiredPageRef.current === 'tracked';
      logger.debug('Ninetailed Next.js Tracker', 'Handle route change got called.', {
        url,
        lastFiredPageUrl: lastFiredPageRef.current,
        isPageAlreadyTracked
      });
      if (!isPageAlreadyTracked) {
        logger.debug('Ninetailed Next.js Tracker', 'Page is not tracked yet, calling the ninetailed.page function.');
        if (typeof onRouteChange === 'function') {
          onRouteChange({
            isInitialRoute: lastFiredPageRef.current === 'none'
          }, ninetailed);
        } else {
          ninetailed.page();
        }
        logger.debug('Ninetailed Next.js Tracker', 'Page got tracked, setting the last fired page to the current url.', url);
        lastFiredPageRef.current = url;
      }
    };
    handleRouteChange(router.asPath);
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      logger.debug('Ninetailed Next.js Tracker', 'Removing the route change listener, as the useEffect hook got unmounted.');
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);
  return null;
};

const _excluded = ["children"],
  _excluded2 = ["onRouteChange"];
const NinetailedProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
      onRouteChange
    } = props,
    providerProps = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/jsxs(NinetailedProvider$1, Object.assign({}, providerProps, {
    children: [/*#__PURE__*/jsx(Tracker, {
      onRouteChange: onRouteChange
    }), children]
  }));
};

export { NinetailedProvider };
